import { resolveSeriesColor, seriesLineStyle } from "@/constants/chart-palette";

type ChartField = { title: string; color: string; hidden?: boolean };
type ChartFields = Record<string, ChartField>;

/** Series with unreliable or incomplete launch ROI data. */
export const EXCLUDED_ROI_SERIES = new Set(["BNB", "SOL"]);

export type RoiLine = {
  dataKey: string;
  name: string;
  stroke: string;
};

export function buildRoiLines(fields: ChartFields | undefined): {
  lines: RoiLine[];
  defaultHidden: string[];
} {
  if (!fields) return { lines: [], defaultHidden: [] };

  const defaultHidden: string[] = [];
  const lines = Object.keys(fields)
    .filter((key) => !EXCLUDED_ROI_SERIES.has(key))
    .map((key, index) => {
      if (fields[key]?.hidden) defaultHidden.push(key);
      const stroke = resolveSeriesColor(key, fields[key].title, index);
      return {
        dataKey: key,
        name: fields[key].title,
        stroke,
        style: seriesLineStyle(stroke),
      };
    });

  return { lines, defaultHidden };
}
